function showLabels(searchQuery){
    return (location.pathname.includes("group") && searchQuery.collectionUid) || location.pathname.includes("mypage")
}

export { showLabels }